<template>
  <nav-bar title="未分配销售组用户" />
  <Content :bottom="0">
    <Loading v-if="showLoading" :zIndex="3" :isLoading="isLoading" @reload="getDataLoading" />
    <ul v-if="list.length" class="list">
      <li class="list-item" v-for="item in list" :key="item.userId">
        <div>{{item.companyName}}</div>
        <div style="margin-top: 10px;">
          <van-button type="primary" size="small" block @click="handleItemClick(item.userId)">分配销售组</van-button>
        </div>
      </li>
    </ul>
    <Empty v-else description="无查询结果" />
  </Content>
  <Popup title="分配销售组" ref="popup" minHeight="100%">
    <van-form @submit="onSubmit">
      <Picker
        label="销售组"
        :columns="checkList"
        text="name"
        :require="true"
        @confirm-values="value => (departId = value.id)"
      />
      <div class="btn">
        <van-button type="primary" native-type="submit" block>提交</van-button>
      </div>
    </van-form>
  </Popup>
</template>

<script>
import { Toast, Notify } from 'vant'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { getNoDistributeUserList, getDepartListByCompanyId, distributeUser } from '@/api/companyList'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'UnassignedUser',
  setup () {
    const store = useStore()
    const list = ref([])
    const companyId = computed(() => store.state.roleInfo.companyId)
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getNoDistributeUserList, (data) => {
      list.value = data
    }, companyId.value)
    getDataLoading()

    const popup = ref(null)
    const departId = ref()
    const checkList = ref([])
    const userId = ref()
    getDepartListByCompanyId(companyId.value).then(res => {
      checkList.value = res.data.map(item => ({
        name: `${item.name}（销售组） - ${item.parentName}（销售部）`,
        id: item.id
      }))
    })
    const handleItemClick = (id) => {
      userId.value = id
      popup.value.showPopup()
    }
    const onSubmit = () => {
      const param = {
        companyId: companyId.value,
        departId: departId.value,
        userId: userId.value
      }
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '请稍后...'
      })
      distributeUser(param).then(() => {
        Toast.clear()
        popup.value.hidePopup()
        getDataLoading()
        Notify({ type: 'success', message: '操作成功' })
      }).catch(() => Toast.clear())
    }
    return { getDataLoading, showLoading, isLoading, list, popup, departId, checkList, onSubmit, handleItemClick }
  }
}
</script>

<style lang="scss" scoped>
.list {
  padding: 0 16px 16px 16px;
  font-size: 14px;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(42, 45, 51, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-top: 16px;
  }
}
.btn {
  margin: 16px;
}
</style>
